import { render, staticRenderFns } from "./Admob.vue?vue&type=template&id=2920220c&"
import script from "./Admob.vue?vue&type=script&lang=js&"
export * from "./Admob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports